import { styled } from '@mui/material/styles';

export const FloatingButtonWrapper = styled('div', {
	shouldForwardProp: prop => prop !== 'index'
})(({ index }) => ({
	position: 'fixed',
	bottom: 40 + 80 * index,
	left: 30,
	zIndex: 1300
}));
